import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  FormControl,
  TextField,
  MenuItem,
  Select,
} from "@mui/material";
import { ToastManager } from "../common/ToastContainer";
import { SESSION_AUTH } from "../../helpers/auth";
import { useParams } from "react-router-dom";
import { EVENTS_SERVICES } from "../../services";
import FullPageProgress from "../common/FullPageProgress";
import { isValidEmail } from "../../helpers/utils";
import { EVENT_TEAM_ROLE } from "../../helpers/constants";

const AddOrgazinationTeamModal = (props) => {
  const { accountId } = useParams();
  const { userSession, LOGOUT_USER_SESSION } = SESSION_AUTH();
  const { onClose, open, onUpdate } = props;
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member");
  const handleClose = () => {
    onClose();
  };

  const createNew = () => {
    if (!email) {
      return ToastManager.addToast("Enter email address");
    }
    if (!isValidEmail(email)) {
      return ToastManager.addToast("Enter valid email address");
    }
    if (!role) {
      return ToastManager.addToast("Enter member role");
    }
    setLoader(true);
    EVENTS_SERVICES.addOrgTeam({
      userId: userSession.userId,
      email: email.trim(),
      role: role,
      id: accountId,
    })
      .then((data) => {
        if (data.code === 200) {
          ToastManager.addToast(data?.message);
          onUpdate();
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
          ToastManager.addToast(data?.message);
        } else {
          ToastManager.addToast(data?.message);
        }
      })
      .catch((error) => {
        ToastManager.addToast(error.message);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-dialog custom-dialog-full"
    >
      {loader && <FullPageProgress />}
      <DialogTitle className="text-center">Add New Member</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 5 }}>
            <FormControl fullWidth>
              <TextField
                type="text"
                xs={12}
                label="Email"
                name="email"
                placeholder="Enter an email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: 2, marginBottom: 5 }}>
            <FormControl fullWidth>
              <Select
                className="custom-select"
                sx={{
                  background: "#131313",
                }}
                value={role}
                onChange={(e) => setRole(e.target.value)}
                displayEmpty
              >
                {Object.keys(EVENT_TEAM_ROLE)
                  .filter((item) => EVENT_TEAM_ROLE[item].allow)
                  .map((item, index) => (
                    <MenuItem key={index} value={EVENT_TEAM_ROLE[item].value}>
                      {EVENT_TEAM_ROLE[item].name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="custom-dialog-action">
        <button
          type="button"
          onClick={handleClose}
          className="custom-dialog-btn  managepro6ix-btn managepro6ix-btn-secondary"
        >
          Canel
        </button>

        <button
          type="button"
          onClick={createNew}
          className="custom-dialog-btn  managepro6ix-btn managepro6ix-btn-primary"
        >
          Save
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default AddOrgazinationTeamModal;
